import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {}

  transform(value: string): SafeUrl {

    if (!value) {
      return value;
    }

    return this.sanitizer.bypassSecurityTrustUrl(value);;
  }

}
